import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import MDTypography from "components/MDTypography";

export default function MDTextInputChip({
  label = "",
  name = "",
  options = [],
  onTextInputChipChange,
}) {
  const [value, setValue] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");

  React.useEffect(() => {
    setValue(options);
  }, [options.length]);

  return (
    <>
      <Autocomplete
        multiple
        freeSolo
        id="tags-standard"
        options={options}
        name={name}
        value={value}
        inputValue={inputValue}
        onChange={(event, newValue) => {
          setValue(newValue);
          onTextInputChipChange({
            name: name,
            value: newValue,
          });
        }}
        onInputChange={(event, newInputValue) => {
          const options = newInputValue.split(",");

          if (options.length > 1) {
            setValue(
              value
                .concat(options)
                .map((x) => x.trim())
                .filter((x) => x)
            );
          } else {
            setInputValue(newInputValue);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder="Use 'Enter' as a delimiter"
          />
        )}
      />
    </>
  );
}
